import { useEffect, useState } from 'react';
import { request } from '@/common';
import { Tooltip } from 'antd';
import agentPageStore from '@/pages/agent-home/store';
import userStore from '@/store/user';
import { observer } from 'mobx-react-lite';
import LimitContent from './limit-content';
import { SVGPureIcon } from '@/ui';
import './index.scss';
import client from '@/store/client';
import namiDetailsStore from '../nami-details/store';
import { HelperCore } from '@/common/dependencies';

const ShowBlance = observer(() => {
  const [mouseHover, setMouseHover] = useState(false);
  const isSe = client.is360se || (HelperCore.isMac() &&  client.isLLQ)
  const agentLimit = agentPageStore.chatLimit;
  const coinBalance = userStore?.coinBalance;
  const is_member = userStore?.membershipInfo?.is_member;
  const member_before = userStore?.membershipInfo?.member_before;

  if (isSe) {
    return null
  }

  if (client.isLLQ) {
    // 大于该版本不展示
    if (client.versionGt('1.3.1388.63')) {
        return null
    }
  }
  return (
    <div
      className={[
        'flex items-center gap-6px h-32px px-12px z-10',
        'hover:bg-[rgba(0,0,0,0.06)] rounded-full cursor-default border-1px border-solid border-[rgba(0,0,0,0.16)]',
      ]}
    >
      <div>
        <img
          src="https://p5.ssl.qhimg.com/t110b9a93014292ae715f275072.png"
          alt=""
          srcset=""
          width={22}
          height={22}
        />
      </div>
      {
        <div>
          {' '}
          <span className="agent-limit-container-num">
            {coinBalance?.balance || 0}
          </span>
        </div>
      }
      <Tooltip align={{ offset: [-10, -16] }} title={<div>查看纳米明细</div>}>
        <div className="flex items-center justify-center text-12px font-400 opacity-50 cursor-pointer" onClick={() => {
            namiDetailsStore.setData({
              show: true,
            });
        }}>
          明细
          <SVGPureIcon name="arrow_right2" size={20} color={'black'} />
        </div>
      </Tooltip>
      {userStore.isUser && member_before && <div id="customer-service-entry" className='w-48px h-48px fixed bottom-24px right-24px z-1000 cursor-pointer'
      onClick={(() => {
        window.open('https://zhike.help.360.cn/?rid=4639ff9f-2b4a-4771-afae-c23dcef5394a&launch_id=ee9c17d7-1342-451b-9808-c94ab63b7f95&_tempAuthType=full', '_blank');
      })}
        onMouseEnter={() => setMouseHover(true)}
        onMouseLeave={() => setMouseHover(false)}
      >
        {mouseHover ? <div className="w-48px h-48px rounded-100px border-1px border-solid text-12px flex flex-wrap items-center justify-center text-center flex-col gap-4px">
            <div className='w-full text-14px h-14px'>会员</div>
            <div className='w-full text-14px h-14px'>客服</div>
            </div> : <img src="https://p4.ssl.qhimg.com/t110b9a9301ce5f7f1e07a4dc83.png" alt="" srcset="" width={48} height={48}/>}
      </div>}
    </div>
  );
});

export default ShowBlance;
